import { useReducer } from 'react'
import {
  DataDownloadResponse,
  DataDownloadSettingsState,
  DataDownloadStateAction,
} from 'Features/DownloadDataModal/DownloadDataModal.types'

export const getInitialSettings = (
  dataDownloadSettings: DataDownloadResponse
) => {
  const { settings } = dataDownloadSettings
  const fileName = settings.fileName ?? 'Work Centre Outputs'
  const fileVersion = settings.fileVersion ?? ['Constrained']
  const keyFigures = settings.keyFigures ?? ['01 Week starting inventory']
  const fileFormat = settings.fileFormat ?? 'csv'
  return {
    fileName,
    fileVersion,
    fileFormat,
    keyFigures,
  }
}

const reducer = (
  state: DataDownloadSettingsState,
  action: DataDownloadStateAction
) => {
  if (action.type === 'SET_FILE_NAME') {
    return {
      ...state,
      fileName: action.payload as string,
    }
  }
  if (action.type === 'SET_FILE_VERSION') {
    return {
      ...state,
      fileVersion: action.payload as string[],
    }
  }
  if (action.type === 'SET_KEY_FIGURES') {
    return {
      ...state,
      keyFigures: action.payload as string[],
    }
  }
  if (action.type === 'SET_FILE_FORMAT') {
    return {
      ...state,
      fileFormat: action.payload as string,
    }
  }
  if (action.type === 'RESET_DATADOWNLOAD_SETTINGS') {
    return getInitialSettings(action.payload as DataDownloadResponse)
  }
  return state
}

export const useDataDownloadSettingsState = (
  initialSettings: DataDownloadResponse
) => {
  return useReducer(reducer, initialSettings, getInitialSettings)
}
